import React from 'react'
import { Link } from 'react-router-dom'
import "./pricingcard.css"

export default function PricingCard() {
    return (
        <>
            <div className="pricing">
            <h1>Pricing</h1>
                <div className="card-container">
                    <div className="card">
                        <h4>-Basic-</h4>
                        <span className="bar"></span>
                        <p className="dollar">$15</p>
                        <p>- 2 Days - </p>
                        <p>- 1 Page - </p>
                        <p>- Featured - </p>
                        <p>- Responsive Design - </p>
                        <p>- Content Upload -</p>
                        <Link to="/contact" className="btn">
                            Purchase
                        </Link>
                    </div>
                    <div className="card">
                        <h4>-Standard-</h4>
                        <span className="bar"></span>
                        <p className="dollar">$25</p>
                        <p>- 3 Days - </p>
                        <p>- 3 Pages - </p>
                        <p>- Featured - </p>
                        <p>- Responsive Design - </p>
                        <p>- Source Code - </p>
                        <p>- Content Upload -</p>
                        <Link to="/contact" className="btn">
                            Purchase
                        </Link>
                    </div>
                    <div className="card">
                        <h4>-Premium-</h4>
                        <span className="bar"></span>
                        <p className="dollar">$40</p>
                        <p>- 5 Days - </p>
                        <p>- 6 Pages - </p>
                        <p>- Featured - </p>
                        <p>- Responsive Design - </p>
                        <p>- Design Customization - </p>
                        <p>- Source Code - </p>
                        <p>- Content Upload -</p>
                        <Link to="/contact" className="btn">
                            Purchase
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
